<template>
  <div class="is-border">
    <div class="has-background-white is-border-bottom is-padding-left row-width-actions-bar">
      <div
        class="columns is-gapless is-vcentered"
        style="min-height:5.656rem">
        <div class="column ">
          <strong class="is-size-3">Agenda</strong>
        </div>
        <div class="column is-narrow is-self-stretched">
          <div class="dropdown is-hoverable is-right is-minH100">
            <div class="dropdown-trigger is-minH100">
              <a class="page-header-btn is-square is-minH100">
                <span
                  class=""
                  aria-haspopup="true"
                  aria-controls="dropdown-menu">
                  <i class="fal fa-filter"></i>
                </span>
              </a>
            </div>
            <div
              class="dropdown-menu"
              id="dropdown-menu"
              role="menu">
              <div class="dropdown-content has-text-left">
                <div class="control dropdown-item is-nowrap">
                  <input
                    id="calendarOptions"
                    type="checkbox"
                    name="column"
                    class="is-checkradio is-circle is-primary"
                    v-model="displayedCalendarEvents"
                    :value="CALENDAR_TYPES.OPTION">
                  <label for="calendarOptions">Options</label>
                </div>
                <div class="control dropdown-item is-nowrap">
                  <input
                    id="reminder"
                    type="checkbox"
                    name="column"
                    class="is-checkradio is-circle is-primary"
                    v-model="displayedCalendarEvents"
                    :value="CALENDAR_TYPES.REMINDER">
                  <label for="reminder">Rappel</label>
                </div>
                <div class="control dropdown-item is-nowrap">
                  <input
                    id="rdv"
                    type="checkbox"
                    name="column"
                    class="is-checkradio is-circle"
                    v-model="displayedCalendarEvents"
                    :value="CALENDAR_TYPES.RDV">
                  <label for="rdv">Rendez-vous</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bulmaCalendar">
      <div class="datetimepicker is-compact is-active is-large is-fullwidth is-cardless">
        <div class="datetimepicker-container">
          <div class="datepicker">
            <div class="datepicker-nav">
              <button
                @click="seePreviousDay"
                class="datepicker-nav-previous button is-text">
                <i
                  class="fal fa-chevron-left"></i>
              </button>
              <router-link
                :to="{name: 'CalendarDay', params: { year: currentDecomposedDay.year, month: currentDecomposedDay.month, day: currentDecomposedDay.day, panel: 'rdvs' }}"
                class="datepicker-nav-month-year is-size-4">
                <div class="datepicker-nav-day is-size-4">
                  {{ currentDecomposedDay.day }}
                </div>
                &nbsp;
                <div class="datepicker-nav-month is-size-4">
                  {{ currentDecomposedDay.month_styled }}
                </div>
                &nbsp;
                <div class="datepicker-nav-year is-size-4">
                  {{ currentDecomposedDay.year }}
                </div>
              </router-link>
              <button
                @click="seeNextDay"
                class="datepicker-nav-next button is-text">
                <i
                  class="fal fa-chevron-right"></i>
              </button>
            </div>
            <div class="datepicker-body is-border-top is-border--dashed">
              <div
                class="datepicker-events is-list"
                v-if="dayEvents.length">
                <router-link
                  :to="{name: 'CalendarDay', params: { year: event.year, month: event.month, day: event.day, panel: event.panel }}"
                  class="datepicker-event is-block is-padding-top-xsmall is-padding-bottom-xsmall is-border-bottom is-padding-left is-padding-right"
                  v-for="(event, i) in dayEvents"
                  :key="'event' + i">
                  <span
                    class="datepicker-event-dot is-vcentered is-margin-right-xxsmall"
                    :class="['is-' + event.type]"></span>
                  <span class="datepicker-event-label">
                    <span
                      class="has-text-grey is-size-6 is-margin-right-xxsmall">{{ event.date | dtFormat('HH[:]mm') }}</span> <span
                      class="is-size-5">&nbsp;<b>{{ event.prefix }}</b> {{ event.label }}</span>
                  </span>
                </router-link>
              </div>
              <div
                class="datepicker-events is-list"
                v-else>
                <i
                  class="is-size-7 datepicker-event is-block is-padding-top-xsmall is-padding-bottom-xsmall is-border-bottom is-padding-left is-padding-right">
                  Aucun événement
                </i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bulmaCalendar">
      <div class="datetimepicker is-compact is-active is-fullwidth is-cardless">
        <div class="datetimepicker-container">
          <div class="datepicker">
            <div class="datepicker">
              <div class="datepicker-nav">
                <button
                  @click="seePreviousMonth"
                  class="datepicker-nav-previous button is-text">
                  <i
                    class="fal fa-chevron-left"></i>
                </button>
                <div class="datepicker-nav-month-year is-size-4">
                  <div class="datepicker-nav-month is-size-4">
                    {{ currentDecomposedMonth.month_styled }}
                  </div>
                  &nbsp;
                  <div class="datepicker-nav-year is-size-4">
                    {{ currentDecomposedMonth.year }}
                  </div>
                </div>
                <button
                  @click="seeNextMonth"
                  class="datepicker-nav-next button is-text">
                  <i
                    class="fal fa-chevron-right"></i>
                </button>
              </div>
            </div>
            <div class="datepicker-body">
              <div class="datepicker-weekdays">
                <div class="datepicker-date is-size-5">
                  <b>Lun.</b>
                </div>
                <div class="datepicker-date is-size-5">
                  <b>Mar.</b>
                </div>
                <div class="datepicker-date is-size-5">
                  <b>Mer.</b>
                </div>
                <div class="datepicker-date is-size-5">
                  <b>Jeu.</b>
                </div>
                <div class="datepicker-date is-size-5">
                  <b>Ven.</b>
                </div>
                <div class="datepicker-date is-size-5">
                  <b>Sam.</b>
                </div>
                <div class="datepicker-date is-size-5">
                  <b>Dim.</b>
                </div>
              </div>
              <div class="datepicker-dates is-active">
                <div class="datepicker-days">
                  <calendar-day-item-compact
                    v-for="day in days"
                    :key="day.key"
                    :reminders="minicalendarReminder"
                    :rdvs="miniCalendarRdv"
                    :options="miniCalendarOption"
                    :current-month="currentMonth"
                    :date="day.date"
                    @updateCurrentDay="updateCurrentDay"
                    :id="day.date.format('MMMMYYYYDD')">
                  </calendar-day-item-compact>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DefaultValues from '@/mixins/DefaultValues.js'
import moment from 'moment'
import calendar from 'node-calendar'
import { mapGetters, mapState } from 'vuex'

const CALENDAR_TYPES = Object.freeze({
  OPTION: 'OPTION',
  RDV: 'RDV',
  REMINDER: 'REMINDER'
})

export default {
  name: 'DashboardCalendar',
  components: {
    CalendarDayItemCompact: () => import('../calendar/CalendarDayItemCompact')
  },
  mixins: [DefaultValues],
  data () {
    return {
      CALENDAR_TYPES: CALENDAR_TYPES,
      currentMonth: moment(),
      currentDay: moment(),
      days: [],
      displayedCalendarEvents: [],
      initialDisplayedCalendarEvents: [CALENDAR_TYPES.OPTION, CALENDAR_TYPES.RDV, CALENDAR_TYPES.REMINDER]
    }
  },
  computed: {
    ...mapGetters(['calendarRdv', 'calendarReminder', 'calendarOption']),
    ...mapState(['currentUser']),
    today () {
      return moment()
    },
    currentDecomposedDay () {
      let result = {
        year: moment(this.currentDay).format('YYYY'),
        month_styled: moment(this.currentDay).format('MMMM'),
        month: moment(this.currentDay).format('MM'),
        day: moment(this.currentDay).format('DD')
      }
      return result
    },
    currentDecomposedMonth () {
      let result = {
        year: moment(this.currentMonth).format('YYYY'),
        month_styled: moment(this.currentMonth).format('MMMM'),
        month: moment(this.currentMonth).format('MM')
      }
      return result
    },
    optionsByDay () {
      let options = this.calendarOption
      let result = []
      for (let option of options) {
        if (moment(option.end_date).isSame(moment(this.currentDay), 'day')) result.push(option)
      }
      return result
    },
    rdvsByDay () {
      let rdvs = this.calendarRdv
      let result = []
      for (let rdv of rdvs) {
        if (moment(rdv.date).isSame(moment(this.currentDay), 'day')) result.push(rdv)
      }
      return result
    },
    remindersByDay () {
      let reminders = this.calendarReminder
      let result = []
      for (let reminder of reminders) {
        if (moment(reminder.date).isSame(moment(this.currentDay), 'day')) result.push(reminder)
      }
      return result
    },
    dayEvents () {
      let events = []
      if (this.displayedCalendarEvents.includes(CALENDAR_TYPES.REMINDER)) {
        for (let reminder of this.remindersByDay) {
          events.push({
            date: reminder.date,
            hour: moment().utc(reminder.date).format('HH:mm'),
            year: moment(reminder.date).format('YYYY'),
            month: moment(reminder.date).format('MM'),
            day: moment(reminder.date).format('DD'),
            panel: 'reminders',
            type: 'danger',
            prefix: 'Rappel :',
            label: reminder.title
          })
        }
      }
      if (this.displayedCalendarEvents.includes(CALENDAR_TYPES.OPTION)) {
        for (let option of this.optionsByDay) {
          events.push({
            date: option.date,
            hour: moment(option.end_date).format('HH:mm'),
            year: moment(option.end_date).format('YYYY'),
            month: moment(option.end_date).format('MM'),
            day: moment(option.end_date).format('DD'),
            panel: 'options',
            type: 'success',
            prefix: 'Fin d\'option :',
            label: `de ${option.user.last_name} ${option.user.first_name} - ${option.lot.ref} `
          })
        }
      }
      if (this.displayedCalendarEvents.includes(CALENDAR_TYPES.RDV)) {
        for (let rdv of this.rdvsByDay) {
          events.push({
            date: rdv.date,
            hour: moment(rdv.date).format('HH:mm'),
            year: moment(rdv.date).format('YYYY'),
            month: moment(rdv.date).format('MM'),
            day: moment(rdv.date).format('DD'),
            panel: 'rdvs',
            type: 'rdv',
            prefix: rdv.rdv_type,
            label: `de ${rdv.user.last_name} ${rdv.user.first_name} avec ${rdv.contact.last_name} ${rdv.contact.first_name} `
          })
        }
      }
      return events
    },
    calendarRangeDate () {
      let date = {
        start: moment(this.currentMonth).subtract(1, 'month').startOf('month').toISOString(),
        end: moment(this.currentMonth).add(1, 'month').endOf('month').toISOString()
      }
      return date
    },
    minicalendarReminder () {
      if (this.displayedCalendarEvents.includes(CALENDAR_TYPES.REMINDER)) {
        return this.calendarReminder
      } else {
        return []
      }
    },
    miniCalendarRdv () {
      if (this.displayedCalendarEvents.includes(CALENDAR_TYPES.RDV)) {
        return this.calendarRdv
      } else {
        return []
      }
    },
    miniCalendarOption () {
      if (this.displayedCalendarEvents.includes(CALENDAR_TYPES.OPTION)) {
        return this.calendarOption
      } else {
        return []
      }
    }
  },
  watch: {
    'displayedCalendarEvents' (v) {
      this.saveConf()
    },
    currentMonth () {
      this.initMonthCalendar()
    }
  },
  created () {
    const conf = this.getConf()
    if (conf) {
      this.displayedCalendarEvents = []
      for (let c of conf) {
        this.displayedCalendarEvents.push(c)
      }
    } else {
      for (const event of this.initialDisplayedCalendarEvents) {
        this.displayedCalendarEvents.push(event)
      }
      this.saveConf()
    }
    this.currentMonth = this.today.clone()
    this.currentDay = this.today.clone()
    this.initMonthCalendar()
  },
  methods: {
    getConf () {
      const localConf = localStorage.getItem('mini_calendar_columnsConf')
      if (localConf) {
        return JSON.parse(localConf)
      }
      return null
    },
    saveConf () {
      localStorage.setItem('mini_calendar_columnsConf', JSON.stringify(this.displayedCalendarEvents))
    },
    updateCurrentDay (date) {
      this.currentDay = moment(date)
    },
    async loadRdvs (page = 1) {
      let params = {
        date__gte: this.calendarRangeDate.start,
        date__lte: this.calendarRangeDate.end,
        per_page: 100,
        account: this.currentUser.account.pk,
        page
      }
      try {
        let request = await this.$api.get(this.$resources.RDV, params)
        for (let rdv of request.data.items) {
          let date = moment(rdv.date)
          let key = date.format('DD/MM/YYYY')
          this.$store.commit('addCalendarEvent', { event: rdv, key: key, type: 'rdvs' })
        }
        if (request.data.page < request.data.pages) {
          this.loadRdvs(++page)
        }
      } catch (err) {
        console.log(err)
      }
    },
    async loadOptions (page = 1) {
      let params = {
        date__gte: this.calendarRangeDate.start,
        date__lte: this.calendarRangeDate.end,
        status: ['waiting_list', 'approved'],
        per_page: 100,
        page
      }
      try {
        let request = await this.$api.get(this.$resources.OPTION, params)
        for (let option of request.data.items) {
          let date = moment(option.end_date)
          let key = date.format('DD/MM/YYYY')
          this.$store.commit('addCalendarEvent', { event: option, key: key, type: 'options' })
        }
        if (request.data.page < request.data.pages) {
          this.loadOptions(++page)
        }
      } catch (err) {
        console.log(err)
      }
    },
    async loadReminders (page = 1) {
      let params = {
        date__gte: this.calendarRangeDate.start,
        date__lte: this.calendarRangeDate.end,
        per_page: 100,
        page
      }
      try {
        let request = await this.$api.get(this.$resources.REMINDER, params)
        for (let reminder of request.data.items) {
          let date = moment(reminder.date)
          let key = date.format('DD/MM/YYYY')
          this.$store.commit('addCalendarEvent', { event: reminder, key: key, type: 'reminders' })
        }
        if (request.data.page < request.data.pages) {
          this.loadReminders(++page)
        }
      } catch (err) {
        console.log(err)
      }
    },
    seePreviousDay () {
      this.currentDay = moment(this.currentDay).subtract(1, 'day')
    },
    seeNextDay () {
      this.currentDay = moment(this.currentDay).add(1, 'day')
    },
    seePreviousMonth () {
      this.currentMonth = moment(this.currentMonth).subtract(1, 'month')
    },
    seeNextMonth () {
      this.currentMonth = moment(this.currentMonth).add(1, 'month')
    },
    initMonthCalendar () {
      this.rdvTotal = 0
      let days = []
      let cal = new calendar.Calendar(0).itermonthdates(this.currentMonth.year(), this.currentMonth.month() + 1)
      cal.forEach(day => {
        days.push({
          key: moment(day).format('DD/MM/YYYY'),
          date: moment(day)
        })
      })
      this.loadRdvs()
      this.loadReminders()
      this.loadOptions()
      this.days = days
    }
  }
}
</script>
